import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useAuth } from "../../../Components/Auth";
import Buttons from "../../../Components/Button/Buttons";
import {
  Avatar,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  Popover,
  Stack,
  TextField,
  useMediaQuery,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Modal from "@mui/material/Modal";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockResetIcon from "@mui/icons-material/LockReset";
import LogoutIcon from "@mui/icons-material/Logout";
import { changePassword } from "../../../../serviceFile/ApiService";
import Toaster from "../../../Components/Toaster";

const theme = createTheme({
  palette: {
    secondary: {
      main: "#00000",
    },
  },
});

export default function ButtonAppBar() {
  const [token, setToken] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [newPasswordErr, setNewPasswordErr] = useState(""); // state used to maintain errors
  const [newPassword, setNewPassword] = useState(""); // state used for store vendor code
  const [confirmPassErr, setConfirmPassErr] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState(null);
  const [oldPassErr, setOldPassErr] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const isSmDown = useMediaQuery("(max-width: 600px)");
  const id = open ? "simple-popover" : undefined;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isSmDown ? "400px" : "750",
    bgcolor: "background.paper",
    border: "2px solid #bbb6b6",
    boxShadow: 24,
    p: 4,
  };

  const handleModalOpen = () => {
    setAnchorEl(null);
    setOpenModal(true);
  };
  const handleModalClose = () => setOpenModal(false);

  useEffect(() => {
    setToken(localStorage.getItem("accessToken"));
  }, []);

  // navigate to login page
  const hanldeLoginNavigate = () => {
    navigate(`/?Logintab=${true}`);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logOut = () => {
    setAnchorEl(null);
    Swal.fire({
      title: "Confirm Logout",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((response) => {
      if (response.isConfirmed) {
        localStorage.clear();
        navigate("/", { replace: true });
        auth.logout();
      }
    });
  };

  const handleLogoNavigate = () => {
    navigate("/");
  };

  function checkChar() {
    const trimmedPassword = newPassword?.replace(/\s/g, "");
    return trimmedPassword?.length >= 8 && trimmedPassword?.length <= 16;
  }

  function checkLower() {
    let reg = /[a-z]/;
    return reg.test(newPassword);
  }

  function checkUpper() {
    let reg = /[A-Z]/;
    return reg.test(newPassword);
  }

  function checkNumber() {
    let reg = /\d/;
    return reg.test(newPassword);
  }

  function checkSpecialCharacter() {
    let reg = /[!@#~`$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    return reg.test(newPassword);
  }

  // change password function
  const handleSubmit = () => {
    let flag = 0;
    const Vcode = localStorage.getItem("vendor_code");
    if (newPassword.trim().length === 0) {
      setNewPasswordErr("Password is required");
      flag = 1;
    }
    if (confirmPassword.trim().length === 0) {
      setConfirmPassErr("Confirm Password is required");
      flag = 1;
    }
    if (oldPassword.trim().length === 0) {
      setConfirmPassErr("Old Password is required");
      flag = 1;
    }
    if (newPassword !== confirmPassword) {
      setConfirmPassErr("Passwords do not match");
      flag = 1;
    }
    if (newPasswordErr !== "" || confirmPassErr !== "" || oldPassErr !== "") {
      return;
    }
    if (flag === 0) {
      const body = {
        new_password: newPassword,
        vendor_code: Vcode,
        old_password: oldPassword,
      };
      changePassword(body)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            localStorage.clear();
            Toaster("Password updated successfully", 1, ["success"]);
            navigate("/");
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message;
          if (err?.response?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("Sorry something went wrong!", 134, ["error"]);
          }
        });
    }
  };

  // function to handle new password validations
  const handleNewPassword = (e) => {
    const newPasswordValue = e?.target?.value;
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/;

    setNewPassword(e.target.value);
    if (
      newPassword === confirmPassword ||
      newPasswordValue === confirmPassword
    ) {
      setConfirmPassErr("");
    }
    if (newPasswordValue === null || newPasswordValue === "")
      setNewPasswordErr("Password is required");
    else if (newPasswordValue.trim().length === 0) {
      setNewPasswordErr("Password is required");
    } else if (!regex.test(newPasswordValue)) {
      setNewPasswordErr("Please enter a valid password");
    } else if (newPasswordValue.trim().length > 16) {
      setNewPasswordErr("Maximum password length is 16");
    } else if (newPasswordValue.trim().length < 8) {
      setNewPasswordErr("Password minimum length is 8");
    } else {
      setNewPasswordErr("");
      setNewPassword(e.target.value);
    }
  };

  // function to handle confirm password
  const handlePassword = (e) => {
    const passwordValue = e?.target?.value;
    setConfirmPassword(passwordValue);
    if (passwordValue === null || passwordValue === "")
      setConfirmPassErr("Confirm password is required");
    else if (passwordValue?.trim().length === 0) {
      setConfirmPassErr("Confirm password is required");
    } else {
      setConfirmPassErr("");
      setConfirmPassword(passwordValue);
    }
  };

  // Function to handle old password
  const handleOldPassword = (e) => {
    const oldPassValue = e?.target?.value;
    setOldPassword(oldPassValue);
    if (oldPassValue === null || oldPassValue === "")
      setOldPassErr("Old password is required");
    else if (oldPassValue?.trim().length === 0) {
      setOldPassErr("Old password is required");
    } else {
      setOldPassErr("");
      setOldPassword(oldPassValue);
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((showConfirmPassword) => !showConfirmPassword);
  const handleClickShowOldPassword = () =>
    setShowOldPassword((showOldPassword) => !showOldPassword);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <AppBar position="fixed" color="">
            <Toolbar>
              <Stack
                direction="row"
                sx={{ display: "flex", justifyContent: "space-between" }}
                width="100%"
              >
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleLogoNavigate}
                >
                  <img
                    src="/assets/images/logo.png"
                    alt="FACT LOGO"
                    width="80"
                    height="35"
                  />
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{
                      fontFamily: "",
                      fontSize: { xs: "14px", sm: "17px", md: "20px" },
                      color: "darkslategray",
                      textShadow: "2px 2px 4px rgba(74,74,74, 0.4)",
                      cursor: "pointer",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                    }}
                  >
                    Vendor Payment tracking
                  </Typography>
                </Stack>
                <Stack
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {token ? (
                    <Avatar
                      onClick={handleClick}
                      alt="Avatar"
                      title="Profile"
                      sx={{ cursor: "pointer", width: 50, height: 50 }}
                      src="data:image/jpeg;base64,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"
                    />
                  ) : (
                    <Buttons
                      text="Login"
                      sx={{ width: "90px" }}
                      onClick={hanldeLoginNavigate}
                    />
                  )}
                </Stack>
              </Stack>
            </Toolbar>
          </AppBar>
        </Box>
      </ThemeProvider>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {/* <Typography sx={{ p: 2 }}>The content of the Popover.</Typography> */}
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Stack direction="row" spacing={1}>
            <Typography variant="subtitle2" noWrap>
              Vendor code: {localStorage.getItem("vendor_code")}
            </Typography>
            {/* <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
              {localStorage.getItem("vendor_code")}
            </Typography> */}
          </Stack>
        </Box>
        <Divider sx={{ borderStyle: "dashed" }} />
        <Divider sx={{ borderStyle: "dashed" }} />
        <MenuItem
          data-testId="logout-Btn"
          onClick={handleModalOpen}
          sx={{ m: 1 }}
        >
          <Stack
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            direction="row"
            spacing={1}
          >
            <LockResetIcon color="warning" />
            <Typography variant="subtitle2" noWrap>
              Change password
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem data-testId="logout-Btn" onClick={logOut} sx={{ m: 1 }}>
          <Stack
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            direction="row"
            spacing={1}
          >
            <LogoutIcon color="info" />
            <Typography variant="subtitle2" noWrap>
              Logout{" "}
            </Typography>
          </Stack>
        </MenuItem>
      </Popover>
      <Modal
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Stack direction={isSmDown ? "column" : "row"}>
              <Stack width={isSmDown ? "100%" : "50%"}>
                <Stack direction="column" spacing={2} sx={{ width: "98%" }}>
                  <img
                    src="/assets/images/password-lock.avif"
                    alt="logo"
                    style={{
                      width: "300px",
                      height: "200px",
                      display: isSmDown ? "none" : "block",
                    }}
                  ></img>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      color: "brown",
                      fontWeight: 600,
                    }}
                  >
                    <ul>
                      <li
                        style={
                          checkChar()
                            ? {
                                transition: "0.4s",
                                color: "green",
                              }
                            : { color: "brown", transition: "0.4s" }
                        }
                      >
                        Password must contain 8 to 16 characters
                      </li>
                      <li
                        style={
                          checkUpper()
                            ? {
                                transition: "0.4s",
                                color: "green",
                              }
                            : { color: "brown", transition: "0.4s" }
                        }
                      >
                        At least one capital letter (A-Z){" "}
                      </li>
                      <li
                        style={
                          checkLower()
                            ? {
                                transition: "0.4s",
                                color: "green",
                              }
                            : { color: "brown", transition: "0.4s" }
                        }
                      >
                        At least one small letter (a-z)
                      </li>
                      <li
                        style={
                          checkNumber()
                            ? {
                                transition: "0.4s",
                                color: "green",
                              }
                            : { color: "brown", transition: "0.4s" }
                        }
                      >
                        At least one number (0-9)
                      </li>
                      <li
                        style={
                          checkSpecialCharacter()
                            ? {
                                transition: "0.4s",
                                color: "green",
                              }
                            : { color: "brown", transition: "0.4s" }
                        }
                      >
                        At least one special character
                      </li>
                    </ul>
                  </Typography>
                </Stack>
              </Stack>
              <Stack width={isSmDown ? "100%" : "50%"}>
                <Stack
                  direction="column"
                  spacing={2}
                  sx={{ width: "70%", marginTop: { xs: "20px", sm: "80px" } }}
                >
                  {/* <img
              src="/assets/images/passwordImage.png"
              alt="logo"
              style={{ width: "390px", height: "280px" }}
            ></img> */}
                  <Typography
                    variant="h6"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      color: "darkslategray",
                      fontWeight: 600,
                      textTransform: "uppercase",
                    }}
                  >
                    Change Password
                  </Typography>
                  <TextField
                    id="outlined-basic"
                    label="Old password"
                    variant="outlined"
                    autoComplete="off"
                    type={showOldPassword ? "text" : "password"}
                    size="medium"
                    margin="dense"
                    error={!!oldPassErr}
                    helperText={oldPassErr}
                    sx={{ width: { xs: "300px", sm: "300px" } }}
                    onChange={(e) => handleOldPassword(e)}
                    InputProps={{
                      shrink: true,
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon
                            style={{ color: "rgb(242, 200, 35) " }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowOldPassword}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showOldPassword ? (
                              <VisibilityOff
                                style={{ color: "rgb(0,0,139)" }}
                              />
                            ) : (
                              <Visibility
                                style={{ color: "rgb(64, 132, 255) " }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    id="outlined-basic"
                    label="New password"
                    variant="outlined"
                    autoComplete="off"
                    type={showPassword ? "text" : "password"}
                    size="medium"
                    margin="dense"
                    error={!!newPasswordErr}
                    helperText={newPasswordErr}
                    sx={{ width: { xs: "300px", sm: "300px" } }}
                    onChange={(e) => handleNewPassword(e)}
                    InputProps={{
                      shrink: true,
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon
                            style={{ color: "rgb(242, 200, 35) " }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? (
                              <VisibilityOff
                                style={{ color: "rgb(0,0,139)" }}
                              />
                            ) : (
                              <Visibility
                                style={{ color: "rgb(64, 132, 255) " }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    id="outlined-password-input"
                    label="Confirm password"
                    variant="outlined"
                    type={showConfirmPassword ? "text" : "password"}
                    autoComplete="current-password"
                    onChange={handlePassword}
                    sx={{ width: { xs: "300px", sm: "300px" } }}
                    error={!!confirmPassErr}
                    helperText={confirmPassErr}
                    InputProps={{
                      shrink: true,
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon
                            style={{ color: "rgb(242, 200, 35) " }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff
                                style={{ color: "rgb(0,0,139)" }}
                              />
                            ) : (
                              <Visibility
                                style={{ color: "rgb(64, 132, 255) " }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Buttons
                    onClick={handleSubmit}
                    sx={{
                      width: { xs: "300px", sm: "300px" },
                      height: 35,
                    }}
                    text="Save password"
                  />
                </Stack>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
